import React from "react";
import {Button, Col, Input, InputGroup, InputGroupAddon, Row,} from "reactstrap";
import "../../assets/css/request-received.css";
import assets from "../../util/assets";
import classNames from "classnames";
import "./index.css";

const RequestSearchComponent = (props) => {

    const clearTextClass = classNames({
        show: props.searchValue && props.searchValue.length > 0,
        "search-user-names-cross": true
    });
    const video = props.video;

    if(props.requestCount > 0){
        return (
            <Row className={classNames({
                "mx-2 mt-4 mb-2 mr-md-5": !video,
                "search-component-padding-8-padding-16": video
            })}>
                <Col className={classNames("text-right", {
                    "px-0 col-sm-12 col-md-5 offset-md-7": !video,
                    "no-padding":video
                })}>
                    <div>
                        <InputGroup className="request-received-search-usernames">
                            <Input
                                name={props.name}
                                data-list={props.list}
                                data-filterlist={props.filterList}
                                data-found={props.found}
                                placeholder="Search user names"
                                className="searchUserNamesPlaceholder rounded-0 search-user-names-placeholder"
                                value={props.searchValue}
                                onChange={props.updateSearchValue}
                            />
                            <img className={clearTextClass} src={assets.clear_search} alt={"clear search"} onClick={props.clearSearch}/>
                            <InputGroupAddon addonType="append">
                                <Button
                                    size="sm"
                                    color=""
                                    className="px-3 py-2 border rounded-0"
                                    style={{backgroundColor: "#FAFAFA"}}
                                    onClick={() => props.searchRequest()}
                                >
                                    <img src={assets.request_received_search} alt={"search"}/>
                                </Button>
                            </InputGroupAddon>
                        </InputGroup>
                    </div>
                </Col>
            </Row>
        )
    }else{
        return(<div/>)
    }
};

export default RequestSearchComponent;